import React from 'react';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import LocationSelectForm from './LocationSelectForm';

type Props = {
  open: boolean;
  onClose: () => void;
  onLocationSelected: (placeId: string, locationName: string) => void;
};

const LocationSelectModal = ({ open, onClose, onLocationSelected }: Props) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Select Location</DialogTitle>
      <DialogContent>
        <LocationSelectForm onClose={onClose} onLocationSelected={onLocationSelected} />
      </DialogContent>
    </Dialog>
  );
};

export default LocationSelectModal;
